import { Gesture, gestureLayers } from "./BaseGesture"

class AgentKeyboardShortcuts extends Gesture {
  override layer = gestureLayers.keyboardShortcut

  override reset(): void { }

  override async onPaste(clipboard: ClipboardEvent) {
    const { capture } = useAnalytics()
    const { addFilesToUserInput } = useAgent()
    const { hasClipboardFiles, state: clipboardState, clearState: clearClipboardState } = useClipboard()

    this.debug("Paste event encountered", clipboard)

    if (!this.isInAgentTextInput(clipboard))
      return this.reset()

    this.capture()
    clearClipboardState()

    // If we don't have files just return after pasting text.
    if (!hasClipboardFiles())
      return this.reset()

    addFilesToUserInput(Object.values(clipboardState.value.files))
    capture("user_pasted_files_into_agent")

    this.reset()
  }

  isInAgentTextInput = (clipboard: ClipboardEvent) => {
    const { panelAgentInputId } = useGlobals()
    return getFirstMatchingParent(
      clipboard.target,
      e => e.id === panelAgentInputId,
    )
  }

  override async onKeyDown(
    keyboard: KeyboardEvent,
  ) {
    // TODO: Keyboard shortcuts we want
    // 1. When you press up on an empty chat, it gives you your prior message
  }
}

const agentKeyboardShortcuts = new AgentKeyboardShortcuts()
export default function () {
  return agentKeyboardShortcuts
}
